import React from 'react';
import * as styles from './CardHeader.module.scss';

interface CardHeaderProps {
  aboveTitle?: React.ReactNode;
  icon?: React.ReactNode;
  title: React.ReactNode;
  meta?: React.ReactNode;
  rightAction?: React.ReactNode;
  rightMeta?: React.ReactNode;
}

const CardHeader = ({
  aboveTitle,
  icon,
  title,
  meta,
  rightAction,
  rightMeta,
}: CardHeaderProps) => (
  <div className={styles.container}>
    {!!icon && <div className={styles.icon}>{icon}</div>}
    {!!aboveTitle && <div className={styles.aboveTitle}>{aboveTitle}</div>}
    <div className={styles.title}>{title}</div>
    {!!meta && <div className={styles.meta}>{meta}</div>}
    {!!rightMeta && <div className={styles.rightMeta}>{rightMeta}</div>}
    {!!rightAction && <div className={styles.rightAction}>{rightAction}</div>}
  </div>
);

export default CardHeader;
